<template>
  <div class="flex gap-4 text-left">
    <u-checkbox v-if="check" :model-value="currentPreference" @update:modelValue="toggle" />
    <u-toggle v-else :model-value="currentPreference" @update:modelValue="toggle"></u-toggle>
    <label class="leading-snug">
      <strong>Automatically make future digitization projects permanent</strong> in my FOREVER<sub class="reg-mark">®</sub> Account if
      I have enough FOREVER Storage<sup>®</sup> space.
    </label>
  </div>
</template>

<script setup>
  const props = defineProps({
    check: Boolean
  });

  const preferences = usePreferencesStore();
  const preference = CURRENT_USER_PREFERENCES.digitizationAutoTransfer;
  const currentPreference = computed(() => preferences.currentUserPreferences[preference]);
  const loading = ref(false);

  async function toggle() {
    try {
      loading.value = true;
      await preferences.updateCurrentUserPreferences({ [preference]: !currentPreference.value });
    } catch (e) {
      console.error("Error toggling preference:", e);
    } finally {
      loading.value = false;
    }
  }
</script>
